import $ from 'jquery';

import {
    getFacebookAppId,
    getFacebookGraphApiVersion,
    getFacebookLoginStatusResponse,
    isFacebookSdkLoaded,
    setFacebookLoginStatusResponse,
    setFacebookSdkLoaded,
} from 'chairisher/context/facebook';
import { submitFormWithRecaptcha } from 'chairisher/view/helper/recaptcha';
import { isTosAccepted, renderDefaultErrorOnTosField } from 'chairisher/view/helper/tosfield';

const FACEBOOK_JSSDK_SCRIPT_ID = 'facebook-jssdk';

/**
 * Asynchronously loads Facebook SDK a maximum of once per page and initializes the callback when SDK is ready.
 *
 * @param {Function} onSdkReady Called by Facebook via window.fbAsyncInit after sdk.js loads.
 */
function injectFacebookSdkScript(onSdkReady) {
    if (!window.FB && !document.getElementById(FACEBOOK_JSSDK_SCRIPT_ID)) {
        window.fbAsyncInit = onSdkReady;
        const firstScript = document.getElementsByTagName('script')[0];
        const js = document.createElement('script');
        js.id = FACEBOOK_JSSDK_SCRIPT_ID;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        firstScript.parentNode.insertBefore(js, firstScript);
    }
}

const bind = function bind() {
    /**
     * Sets access token in the login/create form, indicates attempt is from clicking the facebook button, and submits.
     * @param {jQuery} form The jQuery object representing the form to be mutated and submitted.
     * @param {string} accessToken The user's facebook access token.
     */
    function postFacebookLogin($form, accessToken) {
        $form.find('[name=fb_token]').val(accessToken);
        $form.find('[name=is_provider_initial_attempt]').val('1');
        submitFormWithRecaptcha($form).catch(() => {
            $form.resetLoadingButtons();
        });
    }

    function bindFacebookButtons() {
        // select all unbound FB buttons
        const $btnFacebook = $('.js-btn-facebook:not(.js-is-bound)');

        if ($btnFacebook.length) {
            // disable only the unbound FB buttons
            $btnFacebook.prop('disabled', true);

            // bind the unbound FB buttons
            $btnFacebook.on('click', (e) => {
                e.preventDefault();

                const $btn = $(e.currentTarget);
                const $loginOrCreateForm = $btn.closest('form');

                if (isTosAccepted($loginOrCreateForm)) {
                    $loginOrCreateForm.disableLoadingButtons();
                    $btn.text($btn.data('contacting-text'));

                    const response = getFacebookLoginStatusResponse();

                    if (response.status === 'connected') {
                        postFacebookLogin($loginOrCreateForm, response.authResponse.accessToken);
                    } else {
                        window.FB.login(
                            (loginResponse) => {
                                setFacebookLoginStatusResponse(loginResponse);

                                if (loginResponse.status === 'connected') {
                                    postFacebookLogin($loginOrCreateForm, loginResponse.authResponse.accessToken);
                                } else {
                                    $loginOrCreateForm.resetLoadingButtons();
                                }
                            },
                            { scope: 'public_profile,email' },
                        ); // ask for this data
                    }
                } else {
                    renderDefaultErrorOnTosField($loginOrCreateForm);
                }
            });

            // re-enable the newly bound FB buttons
            $btnFacebook.prop('disabled', false);

            // prevent double binding through exclusion
            $btnFacebook.addClass('js-is-bound');
        }
    }

    function initFacebookLibrary() {
        try {
            window.FB.init({
                appId: getFacebookAppId(),
                cookie: true, // enable cookies to allow the server to access the session
                xfbml: true, // parse social plugins on this page
                version: getFacebookGraphApiVersion(),
            });
            setFacebookSdkLoaded(true);
        } catch (e) {
            setFacebookSdkLoaded(false);
        }

        $('.js-btn-facebook').prop('disabled', true); // disable the button while we fetch login status

        if (isFacebookSdkLoaded()) {
            window.FB.getLoginStatus((response) => {
                setFacebookLoginStatusResponse(response);
            });
            bindFacebookButtons();
        }
    }

    injectFacebookSdkScript(initFacebookLibrary);

    if (getFacebookLoginStatusResponse()) {
        bindFacebookButtons();
    } else if (window.FB) {
        initFacebookLibrary();
    }
};

export default {
    bind,
};
